"use client";

/**
 * 管理后台请求助手：自动附带 x-admin-key（存 localStorage）。
 * 服务端未设置 ADMIN_KEY（本地开发）时 key 为空也能通过。
 */

const KEY_STORAGE = "easyshot_admin_key";

export function getAdminKey(): string {
  if (typeof window === "undefined") return "";
  return window.localStorage.getItem(KEY_STORAGE) ?? "";
}

export function setAdminKey(key: string): void {
  window.localStorage.setItem(KEY_STORAGE, key);
}

export class AdminAuthError extends Error {}

export async function adminFetch<T>(
  path: string,
  init?: RequestInit,
): Promise<T> {
  const request = () => fetch(path, {
    ...init,
    cache: "no-store",
    credentials: "same-origin",
    headers: {
      "content-type": "application/json",
      "x-admin-key": getAdminKey(),
      ...init?.headers,
    },
  });
  let res = await request();
  // Clerk may still be refreshing its short-lived session cookie immediately
  // after a navigation. Do not turn that transient 401 into the legacy key UI.
  if (res.status === 401 && process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY) {
    await new Promise((resolve) => window.setTimeout(resolve, 500));
    res = await request();
  }
  if (res.status === 401) {
    throw new AdminAuthError("Admin session expired");
  }
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(body.error ?? `${res.status} ${path}`);
  }
  return res.json() as Promise<T>;
}
